"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentImportDownloadComponent = void 0;
const core_1 = require("@angular/core");
const app_module_1 = require("./app.module");
const notification_service_1 = require("./notification.service");
const helmFile_1 = require("./helmFile");
const permission_service_1 = require("./permission.service");
let AdjustmentImportDownloadComponent = class AdjustmentImportDownloadComponent {
    constructor(_permission) {
        this._permission = _permission;
        this.reportTypes = { publisher: true, tags: false };
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.permission = this._permission.get();
            this.helmFile = new helmFile_1.HelmFile();
            this.helmFile.reportTypes = this.reportTypes;
        });
    }
    downloadTemplate() {
        let talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
        if (!this.helmFile.reportTypes.publisher && !this.helmFile.reportTypes.tags) {
            talk.broadcast('Please select at least one report type.');
            return;
        }
        this.helmFile.download({
            date: this.date,
            dsp: this.selectedDsp
        });
    }
    canWriteRaw() {
        return this.permission['helm-metric--helm_renders---write'] || this.permission['helm-metric--helm_dfp_revenue---write'];
    }
    canWriteDiscrepancy() {
        return this.permission['helm-metric--helm_renders_discrepancy---write'] || this.permission['helm-metric--helm_dfp_revenue_discrepancy---write'];
    }
    onChangeReportType($event) {
        this.getReportTypes($event.target.name, $event.target.checked);
    }
    getReportTypes(name, isChecked) {
        this.reportTypes[name] = isChecked;
    }
};
exports.AdjustmentImportDownloadComponent = AdjustmentImportDownloadComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentImportDownloadComponent.prototype, "date", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentImportDownloadComponent.prototype, "selectedDsp", void 0);
exports.AdjustmentImportDownloadComponent = AdjustmentImportDownloadComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-import-download',
        templateUrl: 'app/adjustment-import-download.component.html',
        styleUrls: ['styles/adjustment.component.css']
    }),
    __metadata("design:paramtypes", [permission_service_1.PermissionService])
], AdjustmentImportDownloadComponent);
//# sourceMappingURL=adjustment-import-download.component.js.map